import _styled from "@emotion/styled-base";
var _excluded = ["innerRef"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { css } from "@emotion/core";
import * as React from "react";
import tinycolor from "tinycolor2";
import Button from "../Button";
import { forwardInnerRef } from "../utils";
import AlertContext from "./AlertContext";
import { jsx as ___EmotionJSX } from "@emotion/core";

function getHoverBackgroundColor(_ref) {
  var alertTier = _ref.alertTier,
      subtle = _ref.subtle,
      theme = _ref.theme;
  if (!subtle) return "rgba(0, 0, 0, 0.15)";
  var backgroundColor = alertTier ? theme.colors[alertTier] || theme.colors.info : theme.colors.info;
  return tinycolor(backgroundColor).lighten(8).toString();
}

var StyledAlertButton = /*#__PURE__*/_styled(Button, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "alertTier" && prop !== "subtle";
  },
  target: "ezfqoaq0"
})(function (props) {
  var background = getHoverBackgroundColor(props);
  return /*#__PURE__*/css("label:base;box-shadow:none;background:transparent;border:1px solid currentColor;color:currentColor;transform:none;&:active,&:hover{background:", background, ";color:", props.subtle ? props.theme.colors.white : "currentColor", ";border-color:", props.subtle ? background : props.theme.colors.white, ";}");
});

function AlertButton(_ref2) {
  var innerRef = _ref2.innerRef,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var _React$useContext = React.useContext(AlertContext),
      tier = _React$useContext.tier,
      subtle = _React$useContext.subtle;

  return ___EmotionJSX(StyledAlertButton, _extends({
    ref: innerRef
  }, props, {
    alertTier: tier,
    subtle: subtle
  }));
}

export default forwardInnerRef(AlertButton);